import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import I18N from "../../I18N";
import { SuccessButton, DismissButton } from "@myplay/ui";

import AudioAnalyser from "../AudioVisualiser/";

import headsetIcon from "../../assets/icons/headset.svg";

import "./audioCheckWizard.scss";

const YOUTUBE_SET_MIC_LINK = "https://www.youtube.com/watch?v=kYf1FnIgmFE";
const CHANGE_MIC_PERMISSIONS = "https://www.howtogeek.com/411117/how-to-change-a-sites-camera-and-microphone-permissions-in-chrome/";

const StepDots = ({ steps, selectedIndex }) => {
  return (
    <div className="step-dots">
      {steps.map((val, index) => (
        <div
          key={index}
          className={
            selectedIndex === index
              ? "step-dots__dot step-dots__dot--selected"
              : "step-dots__dot"
          }
        />
      ))}
    </div>
  );
};

class AudioCheckWizard extends Component {
  static defaultProps = {};

  static propTypes = {
    mics: PropTypes.array.isRequired,
    handleSelectMic: PropTypes.func.isRequired
  };

  state = {
    step: 0,
    audio: null,
    selectedMic: null
  };

  componentDidMount() {
    this.getMicrophone();
  }

  componentDidUpdate() {
    if (this.props.mics.length > 0 && !this.state.selectedMic) {
      if (this.props.mics[0].deviceId) {
        this.setState({ selectedMic: this.props.mics[0].deviceId });
      }
    }
  }

  async getMicrophone() {
    const audio = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false
    });
    this.setState({ audio });
  }

  connectMicStep = () => {
    return (
      <Fragment>
        <img src={headsetIcon} style={{ width: "95px" }} />
        <p>{I18N.t("CONNECT_MIC_TEXT")}</p>
      </Fragment>
    );
  };

  selectMicStep = () => {
    const { mics } = this.props;
    return mics.length > 0 ? (
      <Fragment>
        <p>{I18N.t("SELECT_MIC")}</p>
        <select
          onChange={event => {
            this.setState({ selectedMic: event.target.value });
          }}
        >
          {mics.map(mic => (
            <option key={mic.deviceId} value={mic.deviceId}>
              {mic.label || "microphone"}
            </option>
          ))}
        </select>
      </Fragment>
    ) : (
      <p>{I18N.t("NO_MIC_FOUND")}</p>
    );
  };
  testMicStep = () => {
    const { audio } = this.state;
    return (
      <Fragment>
        <p>{I18N.t("CHECK_YOUR_MIC")}</p>
        {this.state.audio ? <AudioAnalyser audio={audio} /> : ""}
      </Fragment>
    );
  };

  renderSteps = () => {
    const { step } = this.state;
    this.steps = [
      this.connectMicStep(),
      this.selectMicStep(),
      this.testMicStep()
    ];
    return this.steps[step];
  };

  handleNextStepClick = () => {
    const { handleSelectMic } = this.props;
    const { step, selectedMic } = this.state;
    if (step + 1 < this.steps.length) {
      this.setState(prevState => ({ step: prevState.step + 1 }));
    } else {
      handleSelectMic(selectedMic);
    }
  };

  handlePrevStepClick = () => {
    const { step } = this.state;
    if (step - 1 >= 0) {
      this.setState(prevState => ({ step: prevState.step - 1 }));
    }
  };

  render() {
    const { step, selectedMic } = this.state;
    return (
      <div className="audio-check-wizard">
        {!selectedMic ? (
          <div>
            <p className="audio-check-wizard__title--alert">
              {I18N.t("APPROVE_MIC")}
            </p>
            <a
              target="_blank"
              href={CHANGE_MIC_PERMISSIONS}
              className="audio-check-wizard__title--small"
            >
              {I18N.t("SHOW_ME_HOW")}
            </a>
          </div>
        ) : (
          <div className="audio-check-wizard__step">
            {this.renderSteps()}
            <div>
              {step !== 0 && (
                <DismissButton onClick={this.handlePrevStepClick}>
                  {" "}
                  {I18N.t("PREV")}
                </DismissButton>
              )}
              <SuccessButton
                onClick={this.handleNextStepClick}
                disabled={!selectedMic}
              >
                {this.steps.length === step + 1
                  ? I18N.t("START")
                  : I18N.t("NEXT")}
              </SuccessButton>
            </div>
            <StepDots steps={this.steps} selectedIndex={step} />
          </div>
        )}
      </div>
    );
  }
}

export default AudioCheckWizard;
